import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import LoanProduct from "./pages/LoanProduct";
import CityLoan from "./pages/CityLoan";
import Insurance from "./pages/Insurance";
import CreditScore from "./pages/CreditScore";
import Calculators from "./pages/Calculators";
import FAQs from "./pages/FAQs";
import { BlogList, BlogPost } from "./pages/Blog";
import Contact from "./pages/Contact";
import Career from "./pages/Career";
import LegalPage from "./pages/LegalPage";
import Grievance from "./pages/Grievance";
import Partners from "./pages/Partners";
import CompanyInfo from "./pages/CompanyInfo";
import Admin from "./pages/Admin";

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/loans/:slug" element={<LoanProduct />} />
        <Route path="/loans/:slug/:city" element={<CityLoan />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/credit-score" element={<CreditScore />} />
        <Route path="/calculators/:type" element={<Calculators />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/grievance-redressal" element={<Grievance />} />
        <Route path="/lending-partners" element={<Partners type="lending" />} />
        <Route path="/insurance-partners" element={<Partners type="insurance" />} />
        <Route path="/investors" element={<Partners type="investor" />} />
        <Route path="/company-information" element={<CompanyInfo />} />
        <Route path="/privacy-policy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/disclaimer" element={<LegalPage />} />
        <Route path="/cookie-policy" element={<LegalPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/*" element={<SiteRoutes />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
